import styles from 'styles/_colors.css';

export const sections = [
  {
    title: 'Primary',
    colors: ['red']
  },
  {
    title: 'Neutral',
    colors: ['black']
  },
  {
    title: 'Purples',
    colors: ['purple'],
  },
  {
    title: 'Secondary',
    colors: ['green', 'orange', 'blue']
  }
];

export const colors = {
  red: [
    {
      name: 'Dark Red',
      class: 'dark-red',
      hex: styles['dark-red'],
      rgb: 'RGB(163, 0, 0)',
    },
    {
      name: 'Red',
      class: 'red',
      hex: styles['red'],
      rgb: 'RGB(228, 0, 0)',
    }
  ],
  black: [
    {
      name: 'Black',
      class: 'black',
      hex: styles['black'],
      rgb: 'RGB(0, 0, 0)',
    },
    {
      name: 'Grey',
      class: 'grey',
      hex: styles['grey'],
      rgb: 'RGB(112, 112, 112)',
    },
    {
      name: 'Medium Grey',
      class: 'medium-grey',
      hex: styles['medium-grey'],
      rgb: 'RGB(159, 159, 159)',
    },
    {
      name: 'Light Grey',
      class: 'light-grey',
      hex: styles['light-grey'],
      rgb: 'RGB(212, 212, 212)',
    },
    {
      name: 'Background Grey',
      class: 'background-grey',
      hex: styles['background-grey'],
      rgb: 'RGB(246, 246, 246)',
    },
    {
      name: 'White',
      class: 'white',
      hex: styles['white'],
      rgb: 'RGB(255, 255, 255)',
    }
  ],
  purple: [
    {
      name: 'Dark Purple',
      class: 'dark-purple',
      hex: styles['dark-purple'],
      rgb: 'RGB(74, 46, 94)',
    },
    {
      name: 'Purple',
      class: 'purple',
      hex: styles['purple'],
      rgb: 'RGB(124, 77, 158)',
    },
    {
      name: 'Light Purple',
      class: 'light-purple',
      hex: styles['light-purple'],
      rgb: 'RGB(160, 150, 200)',
    },
    {
      name: 'BG Purple',
      class: 'background-purple',
      hex: styles['background-purple'],
      rgb: 'RGB(239, 240, 244)',
    }
  ],
  blue: [
    {
      name: 'Heavy Blue',
      class: 'heavy-blue',
      hex: styles['heavy-blue'],
      rgb: 'RGB(33, 36, 42)',
    },
    {
      name: 'Dark Blue',
      class: 'dark-blue',
      hex: styles['dark-blue'],
      rgb: 'RGB(46, 50, 58)',
    },
    {
      name: 'Blue',
      class: 'blue',
      hex: styles['blue'],
      rgb: 'RGB(44, 57, 127)',
    },
    {
      name: 'Sky Blue',
      class: 'sky-blue',
      hex: styles['sky-blue'],
      rgb: 'RGB(84, 191, 255)',
    }
  ],
  orange: [
    {
      name: 'Dark Orange',
      class: 'dark-orange',
      hex: styles['dark-orange'],
      rgb: 'RGB(181, 88, 8)',
    },
    {
      name: 'Orange',
      class: 'orange',
      hex: styles['orange'],
      rgb: 'RGB(239, 141, 7)',
    },
    {
      name: 'Yellow',
      class: 'yellow',
      hex: styles['yellow'],
      rgb: 'RGB(253, 196, 0)',
    }
  ],
  green: [
    {
      name: 'Dark Green',
      class: 'dark-green',
      hex: styles['dark-green'],
      rgb: 'RGB(0, 131, 0)',
    },
    {
      name: 'Green',
      class: 'green',
      hex: styles['green'],
      rgb: 'RGB(150, 186, 58)',
    },
    {
      name: 'Lime',
      class: 'lime',
      hex: styles['lime'],
      rgb: 'RGB(211, 208, 0)',
    }
  ]
};



// WEBPACK FOOTER //
// ./src/containers/foundations/Colors/constants.js